window.dt_init = {}

import './pabean_report/goods_receipts'
import './pabean_report/goods_releases'
import './pabean_report/goods_release_exports'
import './pabean_report/finished_goods_mutations'
import './pabean_report/finished_goods_wip_mutations'
import './pabean_report/machine_mutations'
import './admin/users'

window.dtGetUrl = ($table) => {
  const $tab_pane = $table.closest('.tab-pane')
  var url = $tab_pane.attr('id').split("-----"+$tab_pane.attr('uid'))[0]
  url = url.split("nav-")[1]

  return url
}

window.dtShowLoading = function ($table) {
  const cs = $table.find('th').length;
  const loadingRow = `<tr id="loading-row"><td colspan="${cs}" class="text-center"><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></td></tr>`;

  $table.find('tbody').html(loadingRow);
}

window.dtHideLoading = function ($table) {
  $table.find('#loading-row').remove();
}

window.dtRemoveFlexTH = function (elm) {
  // $(elm).find('th').removeClass('d-flex')
}

window.dtFinalTouch = function ($table) {
  const $tab_pane = $table.closest('.tab-pane')

  $tab_pane.find('.dataTables_filter').appendTo($tab_pane.find('#filter_search'));
  $tab_pane.find('.dataTables_filter').appendTo($tab_pane.find('.search-input'));

  $tab_pane.find('.dataTables_length').appendTo($tab_pane.find("#dt-custom-footer"));
  $tab_pane.find('.dataTables_length').prop('style', 'margin-top: 0px !important')
  $tab_pane.find('.dataTables_length').addClass("align-content-center")
  $tab_pane.find('.dataTables_info').appendTo($tab_pane.find("#dt-custom-footer"));
  $tab_pane.find('.dataTables_info').addClass("align-content-center")
  $tab_pane.find('.dataTables_paginate').appendTo($tab_pane.find("#dt-custom-footer"));
  $tab_pane.find('.dataTables_paginate').prop('style', 'margin-top: 0px !important')
}

window.dtTriggerClientExcelExport = function ($btn, tableSelector) {
  const $button = $($btn)
  if ($button.prop('disabled')) return

  $button.prop('disabled', true)

  try {
    $(tableSelector).DataTable().button(0).trigger()
  } finally {
    setTimeout(function () {
      $button.prop('disabled', false)
    }, 1500)
  }
}
